/**
 * Centralized user-facing error messages for status-main-page flows.
 * Keeping messages in one map avoids scattered hard-coded strings.
 */
export const STATUS_MAIN_ERROR_MESSAGES = {
  INTERNAL_NOT_RESOLVED: 'Unable to resolve internal status page.',
  INTERNAL_NO_ACCESS: 'You do not have access to this internal status page.',
  INTERNAL_LOAD_FAILED: 'Unable to load internal status page.',
  ALIAS_NOT_RESOLVED: 'Unable to resolve status page alias.',
  SSO_CALLBACK_FAILED: 'SSO callback validation failed. Please try signing in again.',
  SSO_TOKEN_STILL_UNAUTHORIZED:
    'SSO token was returned but access is still unauthorized. Please contact support.',
  SSO_LOGGED_OUT: 'You are logged out. Click SSO Login to sign in again.',
  SSO_LOGIN_NOT_COMPLETED: 'SSO login did not complete. Please retry in a moment.',
  SSO_START_FAILED: 'Unable to start SSO login. Missing status page id.',
  SSO_REDIRECT_FAILED: 'Unable to redirect to SSO. Missing status page id.',
  SSO_STATUS_PAGE_ID_FAILED: 'Unable to resolve status page id for SSO.',
  SUBSCRIPTION_CONTEXT_MISSING: 'Missing page context. Please refresh and try again.',
  PUBLIC_NOT_FOUND:
    'Status page is not verified, not found, or not published. Please check the link or contact the page owner.'
} as const;

/**
 * Strongly typed keys for STATUS_MAIN_ERROR_MESSAGES.
 */
export type StatusMainErrorKey = keyof typeof STATUS_MAIN_ERROR_MESSAGES;
